import React from 'react';
import {
  Box,
  Button,
  Inline,
  Stack,
  StickerLabel,
  Text,
} from '@stitch-fix/mode-react';
import { ReactComponent as StylistProfilePhoto } from './stylistProfilePhoto.svg';

/**
 * Renders Anchored Fix Promo for clients
 */
const AnchoredFixPromo = ({ skuId }: { skuId: string | null }) => {
  return (
    <Box bgColor="gray-99" p={1}>
      <Stack spacing={0.5}>
        <StickerLabel variant="citrus">New</StickerLabel>
        <Text setting="title-medium">Get styled with this item</Text>
        <Inline spacing={1} my={1} vAlign="center">
          <StylistProfilePhoto />
          <Text setting="body-medium">
            Your Stylist will select pieces for you to create an outfit (or
            two!) with this item.
          </Text>
        </Inline>
        <Button
          as="a"
          href={`https://www.stitchfix.com/fixes/schedule/anchored-fix/${skuId}`}
          width="fill"
        >
          Add to a Fix
        </Button>
      </Stack>
    </Box>
  );
};

export default AnchoredFixPromo;
